<template>
  <div class="wrapper">
    <a><sync-loader :loading="loading"></sync-loader></a>
  </div>
</template>
<script>
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
export default {
  data() {
    return {
      loading: true,
      color: '#000000'
    }
  },
  components: {
    SyncLoader
  }
}
</script>
<style scoped>
  .wrapper {
    position: fixed;
    background-color: rgba(60, 60, 60, 0.60);
    top: 0;
    bottom: 0;
    z-index: 11002;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content {
    font-size: 2em;
    color: white;
  }
  .v-spinner >>> .v-sync{
    background: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Loader.vue